module.exports = __webpack_public_path__ + "img/zsgg-7.8ccf22a3.png";